import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EventManagerService {
    private eventSubject = new Subject<any>();

    constructor() {}

    // Metodo per emettere un evento
    broadcast(event: any) {
        this.eventSubject.next(event);
    }

    // Metodo per ricevere eventi
    on(eventName: string, action: (event: any) => void) {
        return this.eventSubject.asObservable().subscribe(event => {
            if (event.name === eventName) {
                action(event);
            }
        });
    }
}
